export const adaptTipoModulo = (tipoModuloData) => {
    const display = tipoModuloData?.abreviacion + " - " + tipoModuloData?.descripcion;
    return {
        id: tipoModuloData?.idTipoModulo,
        displayName: display,
        name: display,
        abreviacion: tipoModuloData?.abreviacion
    }
}

export const adaptTipoModuloArray = (
    tipoModulos
) => {
    return structuredClone(tipoModulos?.tipoModulos.valorEsperado)
        ?.map(tipoModulo => adaptTipoModulo(tipoModulo));
}